import { render, staticRenderFns } from "./generalWorldMapData.vue?vue&type=template&id=472a24a2&scoped=true"
import script from "./generalWorldMapData.vue?vue&type=script&lang=js"
export * from "./generalWorldMapData.vue?vue&type=script&lang=js"
import style0 from "./generalWorldMapData.vue?vue&type=style&index=0&id=472a24a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472a24a2",
  null
  
)

export default component.exports